const genericErrorMessage =
  'There appears to be a problem, please contact support if this continues.';

export { genericErrorMessage };
